module.exports = __webpack_public_path__ + "img/cerade.1756f3cb.jpg";